<template>
  <ul class="row list-unstyled mx-auto p-inline-start-0 ticket-tabs">
    <li v-for="(tab, index) in tabs" :key="index" v-bind:class="{ 'active': tab.val === activeTab }" class="mr-2">
      <button v-on:click.prevent="$emit('changed', tab.val)" class="btn d-flex align-items-center">
        <span class="icon mr-2" :class="tabIcon(tab.val)" aria-hidden="true"></span>
        {{ $t('common.ticketType.' + tab.val) }} ({{ tab.count }})
      </button>
    </li>
  </ul>
</template>

<script lang="ts">
import { TicketStatusEnum } from '@/generated/openapi';
import { defineComponent, PropType } from 'vue';

export interface TabsTicketTypeOption {
  val: TicketStatusEnum;
  count: number;
}

export default defineComponent({
  name: 'TabsTicketType',
  props: {
    activeTab: {
      type: String as PropType<TicketStatusEnum>,
      required: true
    },
    tabs: {
      type: Array as PropType<TabsTicketTypeOption[]>,
      required: true
    }
  },
  methods: {
    tabIcon(tab: TicketStatusEnum){
      if(tab === "BOOKED") return "icon-alert_success"
      else if(tab === "CANCELLED") return "icon-alert_fehler"
      else return ""
    }
  }
});
</script>
